import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {ResidentForSelect} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {ParcelsService} from '../../../services/parcels.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'parcel-detailed-view',
    templateUrl: './parcel-detailed-view.component.html',
    styleUrls: ['./parcel-detailed-view.component.scss']
})

export class ParcelDetailedViewComponent {
    navPosition = 'details';
    comment = '';
    suites = [];
    residents = [];
    buildingSelectIsDisabled = false;

    constructor(public api: ApiClientService,
                public parcelsService: ParcelsService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService
    ) {
    }

    onSubmit(data: any): void {
        const url = `/v1/parcels/${this.parcelsService.selectedItemData.id}.json`;
        this.parcelsService.api.patch('domainParcels', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.parcelsService.toggleDetailedView(this.parcelsService.selectedItemData, true);
        this.parcelsService.getData();
        if (close) this.parcelsService.toggleDetailedView(null, false);
    }

    isNotObject(item) {
        return typeof item != 'object';
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        this.setEditModeForAll(false);
        if (fieldName != 'building' && fieldName != 'unit' && fieldName != 'resident')
            item.formFields[fieldName].editMode = state;
        else {
            if (state) {
                this.getSuites(this.parcelsService.selectedItemData.buildingId, this.parcelsService.selectedItemData.suiteId, form);
                if (this.parcelsService.selectedItemData.suiteId === 0)
                    this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            item.formFields['building'].editMode = state;
            item.formFields['unit'].editMode = state;
            item.formFields['resident'].editMode = state;
        }
    }

    setEditModeForAll(state: boolean) {
        for (const field in this.parcelsService.selectedItemData.formFields)
            this.parcelsService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField?: string) {
        const formValue = {...form.value};
        if (form.dirty) {
            if (formField) {
                item[formField] = form.value[formField];
                if (formField == 'building' || formField == 'unit' || formField == 'resident') {
                    if (this.parcelsService.buildings.length === 1) {
                        formValue.building = this.parcelsService.selectedItemData.buildingId;
                    }
                    if (!formValue.building ||
                        !(formValue.unit || (formValue.unit === 0 && formValue.otherSuite)) ||
                        !(formValue.resident || (formValue.resident === 0 && formValue.otherResident))) {
                        toastr.warning('All details about building, unit and resident must be filled to proceed.');
                        return;
                    }
                    const building = this.parcelsService.buildings.find((item) => +item.id === +formValue.building);
                    const suite = this.suites.find((item) => +item.id === +formValue.unit);
                    const resident = this.residents.find((item) => +item.id === +formValue.resident);
                    changedValue = {
                        building: {
                            bdId: form.value.building,
                            name: building ? building.name : null,
                            address: building ? building.address : null,
                            corporationNumberBd: building ? building.corporationNumber : null,
                            timezone: building ? (building.timeZone ? building.timeZone.value : null) : null
                        },
                        suite: {
                            bdId: suite.id ? form.value.unit : 0,
                            suiteNumber: suite.id ? suite.name : formValue.otherSuite,
                        },
                        resident: {
                            bdId: resident.id ? resident.id : 0,
                            fullName: resident.id ? resident.fullName : formValue.otherResident,
                            //Fixme: add resident email
                        },
                    };
                }
                if (formField === 'parcelPostService') {
                    changedValue = {
                        parcelPostServiceName: changedValue.parcelPostService === '-1' ?
                            changedValue.parcelPostServiceName
                            : this.parcelsService.postServices.find(ps => ps.id == changedValue.parcelPostService).name
                    };
                    changedValue.parcelPostService = formValue.parcelPostService !== '-1' ? formValue.parcelPostService : null;
                }
            }
            if (changedValue.numberPieces && changedValue.numberPieces <= 0) {
                toastr.warning('Pieces can not be less than 1');
                return;
            }
            this.onSubmit(changedValue);
            if (form.valid) this.setEditModeForAll(false);
        } else {
            this.setEditModeForAll(false);
        }
    }

    changeBuilding(buildingId: string, form) {
        form.controls['unit'].reset();
        form.controls['resident'].reset();
        this.getSuites(+buildingId, null, form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId, form);
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        if (form.controls['resident'].value !== 0)
            form.controls['resident'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['resident'].setValue(0);
            setTimeout(() => {
                form.controls['otherSuite'].reset();
                form.controls['otherResident'].reset();
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if (form.value.unit !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(
                        item => (new ResidentForSelect(item.id, item.fullName, [], item.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    receiverHasEmailOrPhone(item) {
        return item.residentEmail || item.residentMobilePhone;
    }

    changeResident(residentId: number) {
        if (!+residentId)
            this.parcelsService.selectedItemData.residentFullName = '';
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-detailed-view/parcel-detailed-view.component.ts